import { createActionConst } from '../../../utils/action.utils';

const MEETING_PAGE_NAMESPACE = 'MEETING_PAGE';

export const INITIAL_MEETING_PAGE = createActionConst(MEETING_PAGE_NAMESPACE, 'INITIAL_MEETING_PAGE');
